import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AumicoIntegrationsConfig, AumicoIntegrationsConfigService } from '../aumico-integrations.config';
import { IPartnerConnection } from '../models/outbound/partner-connection.model';

@Injectable()
export class PartnerConnectionService {
    private readonly endpoint: string;

    public constructor(
        private readonly http: HttpClient,
        @Inject(AumicoIntegrationsConfigService) config: AumicoIntegrationsConfig,
    ) {
        this.endpoint = `${config.apiGateway}partner-connections`;
    }

    public list(): Observable<IPartnerConnection[]> {
        return this.http.get<IPartnerConnection[]>(this.endpoint);
    }

    public disconnect(clientId: string): Observable<void> {
        return this.http.delete<void>(`${this.endpoint}/${clientId}`);
    }
}
